import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { EditAdvertisementFormDataType } from "@/dialogs/advertisements/EditAdvertisementDialog"

function useUpdateAdvertisementDetails() {
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number
      data: EditAdvertisementFormDataType
    }) => {
      return client
        .put(`/advertisements/${id}/details`, data)
        .then((response) => response.data)
    },
  })
}

export default useUpdateAdvertisementDetails
